import React from 'react';
import FullPageLayout from '../../components/layouts/FullPageLayout';
import NoMatch from '../../components/blocks/NoMatch';

function NoMatchContainer(props) {
  return (
    <FullPageLayout>
      <NoMatch />
    </FullPageLayout>
  );
}

export default NoMatchContainer;
